export const handle404 = error => {
  if (error?.errors?.length) {
    const { errorType } = error.errors[0];

    if (errorType === 'NotFound') {
      window.location.href = '/user/classes/404/';
    }
  }
};
